import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_my_einvoice_tin_update_request_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    request_line_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    access_key: fromDatatype.VarcharDatatypeInterface;
    email_notification_count: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_my_einvoice_tin_update_request_queue_RowClass implements bl_fi_my_einvoice_tin_update_request_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    request_line_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    access_key: fromDatatype.VarcharDatatypeInterface;
    email_notification_count: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
}